export const VIDEO_LINK =
  'https://player.vimeo.com/video/1064490335?muted=1&autoplay=1&controls=0&loop=1&app_id=122963'

export const VIDEO_RATIO = 1.77777777
